/**
 * Verifica se l'utente loggato deve aggiornare il proprio metodo di pagamento
 *
 * @param firebaseUid L'UID Firebase dell'utente loggato
 * @returns Boolean che indica se l'utente deve aggiornare il metodo di pagamento
 */
export const checkPaymentStatus = async (firebaseUid: string): Promise<boolean> => {
  try {
    const response = await fetch(`${process.env.NEXT_PUBLIC_HOST}/api/customer/payment-status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ firebaseUid }),
    });

    if (!response.ok) {
      console.error('Error checking payment status:', response.statusText);
      return false;
    }

    const data = await response.json();
    return data.needsToUpdatePayment || false;
  } catch (error) {
    console.error('Failed to check payment status:', error);
    return false;
  }
};
